export default {
  theme: {
    g: {
      title: "从毕加索到基弗—路德<br>维希的艺术课",
      textDetail: `展览将59位艺术家的64件作品分为16个单位，每单元视为一节课，通过16课诠释欧美现代艺术史上的16种风格、流派或运动。观看展览，犹如聆听生动的西方现代艺术课，让观众能欣赏、享受欧美现代艺术的魅力，能感知、体悟中西方文化交流的魅力。`,
      remark: `2019年度特展`,
      time: '2019年3月10日—6月9日',
      arrowDown: false,
      theme: "blue",
      id: "g",
      imageNumber: 0,
      video: [
        {
          cover: 'video17.jpg',
          video: '毕加索展览(成片）.mp4'
        }
      ],
      link: [
        {
          cover: 'scene17.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=5bpWKswR'
        }
      ]
    },
    h: {
      title: "世界巨匠—意大利<br>文艺复兴三杰",
      textDetail: `南京博物院和意大利梅塔莫弗斯文化基金会共同主办。展览定位为“以文艺复兴艺术三杰：达·芬奇、米开朗基罗、拉斐尔艺术为主的公元14至15世纪西方美术展”，展出“三杰”及其追随者的油画、雕塑、素描、手稿等68件（套）。通过展品图文解读配以视频解读、语音导览、智慧导览、展览图录、社教活动、文创开发等，全方位、多角度地呈现了“三杰”艺术成就及其产生的深远影响。`,
      remark: `第十七届（2019年度）全国博物馆十大陈列展览精品国际及港澳台合作奖`,
      time: '2018年11月28日—2019年2月24日',
      arrowDown: false,
      theme: "blue",
      id: "h",
      imageNumber: 0,
      video: [
        {
          cover: 'video16.jpg',
          video: '文艺复兴三杰展1214.mp4'
        }
      ],
      link: [
        {
          cover: 'scene16.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=7RP2UF3b&lang=zh'
        }
      ]
    },
    i: {
      title: "万水千山—南京博物院<br>藏历代山水画迎春特展",
      textDetail: ``,
      remark: ``,
      time: '2022年1月20日—',
      arrowDown: false,
      theme: "blue",
      id: "i",
      imageNumber: 0,
      video: [
        {
          cover: 'video28.jpg',
          video: '万水千山成片定稿.mp4'
        }
      ],
      link: [],
    },
    j: {
      title: "称霸侏罗纪—我是一只<br>威猛的恐龙",
      textDetail: `南京博物院与四川自贡恐龙博物馆合作举办的“称霸侏罗纪——我是一只威猛的恐龙”亲子主题展，是南博首次尝试举办儿童科普展。展品包括20具大型恐龙和伴生动物骨架，29件恐龙牙齿、恐龙蛋以及动植物化石的典型标本。展览以侏罗纪霸主——永川龙为主角，用倒叙的手法讲述了我的世界、我很勇敢、原来我曾经这么小、我要成为威猛的恐龙的故事，让亲子家庭通过观看展览、阅读绘本、绘制拓片、观看影片等方式，走近一个立体的侏罗纪世界。`,
      remark: `2018年度暑期特展`,
      time: '2018年7月14日—10月7日',
      arrowDown: false,
      theme: "blue",
      id: "j",
      imageNumber: 0,
      video: [
        {
          cover: 'video15.jpg',
          video: '称霸侏罗纪.mp4'
        }
      ],
      link: [
        {
          cover: 'scene15.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=9JB1VvGO'
        }
      ]
    },
    k: {
      title: "金色阿富汗—古代<br>文明的十字路口",
      textDetail: `展览以“古代文明的十字路口”为主线，通过阿富汗北部的法罗尔、阿伊哈努姆、蒂拉、贝格拉姆等4个遗址出土的231 组1406 件文物，展现融合了古希腊、古波斯、古印度、古代中国文明的“阿富汗文明”，在欧亚大陆古代文明传播和交融上的独特角色和地位。“金色阿富汗”是对展览主要组成部分、来自蒂拉丘地的金器的概括。`,
      remark: `2019年度交流展`,
      time: '2019年7月9日—10月9日',
      arrowDown: false,
      theme: "blue",
      id: "k",
      imageNumber: 0,
      video: [
        {
          cover: 'video19.jpg',
          video: '金色阿富汗.mp4'
        }
      ],
      link: [
        {
          cover: 'scene19.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=9BwEleII&lang=zh'
        }
      ]
    },
    l: {
      title: "暑期动物“缘”",
      textDetail: `展览以动物为主题，通过院藏文物、动物标本、互动体验等，集知识性、互动性和娱乐性于一体，带领孩子们感受人与动物的美好情缘。展览分为三个部分，第一部分通过与动物相关的院藏文物阐发人与动物之间豢养与共生的密切关系；第二部分通过多媒体、体验装置等，引导孩子们认识水、陆、空三个空间的动物群，并举例说明动物的某些特性对于人类科技发展具有的启发意义；第三部分展示濒危动物的标本，通过沉浸式场景的营造，发出保护动物、爱护环境的倡议。`,
      remark: `2019年度暑期特展`,
      time: '2019年6月28日—8月31日',
      arrowDown: false,
      theme: "blue",
      id: "l",
      imageNumber: 0,
      video: [
        {
          cover: 'video18.jpg',
          video: '暑期动物缘展览视频(最终）.mp4'
        }
      ],
      link: [
        {
          cover: 'scene18.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=MXsQEyTX&lang=zh'
        }
      ]
    },
    m: {
      title: "晶华—矿物之至善至美",
      textDetail: `展览从璀璨夺目、巧工呈美、文华生辉三个方面，通过来自世界各地的350件（组）矿物精品和南京博物院的近百件与矿物相关的青铜器、铜胎掐丝珐琅（景泰蓝）、瓷器、紫砂器、金银器、珠宝首饰等，表现矿物的至善至美。`,
      remark: `2020年跨年特展`,
      time: '2020年11月26日—2021年5月5日',
      arrowDown: false,
      theme: "blue",
      id: "m",
      imageNumber: 0,
      video: [
        {
          cover: 'video23.jpg',
          video: '晶华展视频.mp4'
        }
      ],
      link: [
        {
          cover: 'scene23.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=a3hbD5cCO&lang=zh'
        }
      ]
    },
    n: {
      title: "浮世绘艺术",
      textDetail: `展览集中了中国美术馆藏日本浮世绘代表作72幅，南京博物院藏日本文物79件，依据浮世绘的主要类别——美人图、役者绘、风景花鸟画，分为“风重人娇春将归”“宛然如一梦，彼此记心头”“满眼青山耳杜鹃”三个单元，呈现了浮世绘艺术在描绘市井生活、人物百态和自然风景上的独特魅力，并以此促进中日文化的借鉴、传播和交流。`,
      remark: `2021年度特展`,
      time: '2021年7月21日—12月19日',
      arrowDown: false,
      theme: "blue",
      id: "n",
      imageNumber: 0,
      video: [
        {
          cover: 'video26.jpg',
          video: '浮世绘（完整版）.mp4'
        }
      ],
      link: [
        {
          cover: 'scene26.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=pD9m7WcE6&lang=zh'
        }
      ]
    },
  },
  wuyiba: {
    aa: {
      title: "家·国—中国传统人<br>伦精神展演",
      textDetail: `本展览以家国情怀为核心，表达出家国情怀是华夏儿女的文化观念形态，家庭是国家建设和发展的力量之源，家庭同国家、民族的前途命运紧密相连。围绕着个人和父母、个人和配偶、个人和兄弟姐妹、个人和朋友之间、个人和国家、个人和社会的关系去阐释家国情怀的具体内涵，选取契合社会主义核心价值观的文物及非遗项目进行组合展示。展览共设五个单元，于2022年5月18日开幕；非遗活态展演主要围绕2022年端午、七夕、中秋、重阳几个传统节日和元旦迎新至来年春节的重要时间点依序开展，共计10个月展期；文物展2022年11月开展，延续至2023年10月，共计12个月展期。`,
      remark: `国家文物局2022年度“弘扬中华优秀传统文化，培育社会主义核心价值观”主题展览征集重点推介项目`,
      time: '2022年5月18日-2023年2月5日',
      arrowDown: false,
      id: "aa",
      imageNumber: 22,
      video: [
        {
          cover: 'cover.jpg',
          video: '518视频.mp4',
        },
        {
          cover: 'cover.jpg',
          video: '20220716-17快闪视频',
        },
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KJ-KRvcfNMAKG',
        },
      ],
    },
    ab: {
      title: "家·国—中国传统人<br>伦精神展演",
      textDetail: `本展览以家国情怀为核心，表达出家国情怀是华夏儿女的文化观念形态，家庭是国家建设和发展的力量之源，家庭同国家、民族的前途命运紧密相连。围绕着个人和父母、个人和配偶、个人和兄弟姐妹、个人和朋友之间、个人和国家、个人和社会的关系去阐释家国情怀的具体内涵，选取契合社会主义核心价值观的文物及非遗项目进行组合展示。展览共设五个单元，于2022年5月18日开幕；非遗活态展演主要围绕2022年端午、七夕、中秋、重阳几个传统节日和元旦迎新至来年春节的重要时间点依序开展，共计10个月展期；文物展2022年11月开展，延续至2023年10月，共计12个月展期。`,
      remark: `国家文物局2022年度“弘扬中华优秀传统文化，培育社会主义核心价值观”主题展览征集重点推介项目`,
      time: '2022年5月18日-2023年2月5日',
      arrowDown: false,
      id: "ab",
      imageNumber: 1,
      video: [
        {
          cover: 'cover.jpg',
          video: '518视频.mp4',
        },
        {
          cover: 'cover.jpg',
          video: '20220716-17快闪视频',
        },
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KJ-KRvcfNMAKG',
        },
      ],
    },
    ac: {
      title: "家·国—中国传统人<br>伦精神展演",
      textDetail: `本展览以家国情怀为核心，表达出家国情怀是华夏儿女的文化观念形态，家庭是国家建设和发展的力量之源，家庭同国家、民族的前途命运紧密相连。围绕着个人和父母、个人和配偶、个人和兄弟姐妹、个人和朋友之间、个人和国家、个人和社会的关系去阐释家国情怀的具体内涵，选取契合社会主义核心价值观的文物及非遗项目进行组合展示。展览共设五个单元，于2022年5月18日开幕；非遗活态展演主要围绕2022年端午、七夕、中秋、重阳几个传统节日和元旦迎新至来年春节的重要时间点依序开展，共计10个月展期；文物展2022年11月开展，延续至2023年10月，共计12个月展期。`,
      remark: `国家文物局2022年度“弘扬中华优秀传统文化，培育社会主义核心价值观”主题展览征集重点推介项目`,
      time: '2022年5月18日-2023年2月5日',
      arrowDown: false,
      id: "ac",
      imageNumber: 1,
      video: [
        {
          cover: 'cover.jpg',
          video: '518视频.mp4',
        },
        {
          cover: 'cover.jpg',
          video: '20220716-17快闪视频',
        },
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KJ-KRvcfNMAKG',
        },
      ],
    },
    ad: {
      title: "家·国—中国传统人<br>伦精神展演",
      textDetail: `本展览以家国情怀为核心，表达出家国情怀是华夏儿女的文化观念形态，家庭是国家建设和发展的力量之源，家庭同国家、民族的前途命运紧密相连。围绕着个人和父母、个人和配偶、个人和兄弟姐妹、个人和朋友之间、个人和国家、个人和社会的关系去阐释家国情怀的具体内涵，选取契合社会主义核心价值观的文物及非遗项目进行组合展示。展览共设五个单元，于2022年5月18日开幕；非遗活态展演主要围绕2022年端午、七夕、中秋、重阳几个传统节日和元旦迎新至来年春节的重要时间点依序开展，共计10个月展期；文物展2022年11月开展，延续至2023年10月，共计12个月展期。`,
      remark: `国家文物局2022年度“弘扬中华优秀传统文化，培育社会主义核心价值观”主题展览征集重点推介项目`,
      time: '2022年5月18日-2023年2月5日',
      arrowDown: false,
      id: "ad",
      imageNumber: 2,
      video: [
        {
          cover: 'cover.jpg',
          video: '518视频.mp4',
        },
        {
          cover: 'cover.jpg',
          video: '20220716-17快闪视频',
        },
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KJ-KRvcfNMAKG',
        },
      ],
    },
    ae: {
      title: "家·国—中国传统人<br>伦精神展演",
      textDetail: `本展览以家国情怀为核心，表达出家国情怀是华夏儿女的文化观念形态，家庭是国家建设和发展的力量之源，家庭同国家、民族的前途命运紧密相连。围绕着个人和父母、个人和配偶、个人和兄弟姐妹、个人和朋友之间、个人和国家、个人和社会的关系去阐释家国情怀的具体内涵，选取契合社会主义核心价值观的文物及非遗项目进行组合展示。展览共设五个单元，于2022年5月18日开幕；非遗活态展演主要围绕2022年端午、七夕、中秋、重阳几个传统节日和元旦迎新至来年春节的重要时间点依序开展，共计10个月展期；文物展2022年11月开展，延续至2023年10月，共计12个月展期。`,
      remark: `国家文物局2022年度“弘扬中华优秀传统文化，培育社会主义核心价值观”主题展览征集重点推介项目`,
      time: '2022年5月18日-2023年2月5日',
      arrowDown: false,
      id: "ae",
      imageNumber: 7,
      video: [
        {
          cover: 'cover.jpg',
          video: '518视频.mp4',
        },
        {
          cover: 'cover.jpg',
          video: '20220716-17快闪视频',
        },
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KJ-KRvcfNMAKG',
        },
      ],
    },
    a: {
      title: "在此—中国生活<br>艺术展",
      textDetail: `南京博物院、中国室内装饰协会陈设艺术专业委员会、北京市书院中国文化发展基金会联合举办。旨在通过创造富有传统文化气息的启发式悟境，使参与者感受到中国传统“雅生活”之魅力，提升参与者的心灵体验及精神意趣。展览融合中国传统文人的九大雅事“琴、棋、书、画、诗、酒、花、香、茶”，通过生活形式的艺术化，将传统文化精神融进当代生活。`,
      remark: `2014 年“5·18 国际博物馆日”中国主会场特展`,
      time: '2015年5月18日—6月24日',
      arrowDown: false,
      id: "a",
      imageNumber: 9,
      video: [
        {
          cover: 'video.jpg',
          video: '在此展览--中国陈设艺术专业委员会出品.mp4',
        }
      ],
      link: [],
    },
    b: {
      title: "缀白裘—南京博物院<br>藏品征集十年",
      textDetail: `文物征集是博物馆工作的重要组成部分。2006 年以来的十年间，5000 多件（套）征集文物已经按照藏品主题和序列由单一的个体或组合融入了南京博物院庞大的藏品体系中。展览不仅整合展示征集藏品本身，更重要的是展现藏品征集工作为社会服务、为公众服务的理念。缀，是补缀，是联缀，更是点缀，十年间，南博藏品结构在一点点的补充中更加完善，发挥的社会效能也在不断扩大。`,
      remark: `2017 年“5·18 国际博物馆日”主题特展`,
      time: '2017年5月16日—8月16日',
      arrowDown: false,
      id: "b",
      imageNumber: 8,
      video: [
        {
          cover: 'video9.jpg',
          video: '缀白裘展览视频.mp4'
        }
      ],
      link: [],
    },
    c: {
      title: "呼吸—中国传统文化<br>中的当代形塑",
      textDetail: `展览是我国博物馆首次有主题地引入富于中国传统文化内涵的雕塑艺术作品展，也是南博在传统文化和当代生活艺术展览上的有益尝试。29 位中国当代雕塑家特别打造了59 件既符合南博特色，又具备中国传统文化精神的雕塑作品。展览取名“呼吸”，一方面来自博物馆展览内容中对传统文化的理解和对当代创造的追求，另一方面来自于对博物馆空间特色化与舒适感的要求，来自公众对博物馆空间环境的感受。`,
      remark: `2016 年“5·18 国际博物馆日”主题展`,
      time: '2016年5月18日—7月17日',
      arrowDown: false,
      id: "c",
      imageNumber: 5,
      video: [
        {
          cover: '4.jpg',
          video: '呼吸.mp4',
        }
      ],
      link: [],
    },
    d: {
      title: "穆夏—欧洲新艺<br>术运动瑰宝",
      textDetail: `展览由南京博物院和捷克国家工艺美术博物馆、布拉格市艺术博物馆共同主办。依循穆夏的生活与艺术发展脉络及新艺术运动所波及的领域，将184 件（套）穆夏作品（部分艺术品、家具为其他捷克新艺术运动艺术家的作品）分为海报艺术风尚、民族宗教情怀两大部分展出，包括绘画、雕塑、海报、家具等。从早期海报的柔美明快，到晚期油画的自由赤诚，展览全面阐释了穆夏的美学风格。`,
      remark: `2018 年“5·18 国际博物馆日”主题特展；首届（2018年度）江苏省博物馆十大陈列展览精品国际及港澳台合作奖`,
      time: '2018年5月18日—8月28日',
      arrowDown: false,
      id: "d",
      imageNumber: 0,
      video: [
        {
          cover: 'video14.jpg',
          video: '穆夏展览视频.mp4'
        }
      ],
      link: [
        {
          cover: 'scene.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=Hd36Qlj5&lang=zh'
        }
      ]
    },
    e: {
      title: "融·合：从春秋到秦汉—中国<br>传统文化中的 多元与包容",
      textDetail: `展览由南京博物院联合河南博物院、河北博物院、陕西历史博物馆等八家省级文博机构共同举办。展览以“融·合”为核心，以“春秋到秦汉”历史时段为落点，以“中国传统文化中的多元与包容”为阐释重点，以宏大的文化视角表达波澜壮阔的“中国传统文化奠基史”上表现出的自强不息的创新精神、平等共生的处世之道和海纳百川的开放胸怀。展览展出文物275 件（套），从政治经济、思想文化、社会生活、交流融合等四个方面，通过“群雄并起、华夏一统”“百家争鸣、重礼尊儒”“百工巧技、器以载道”“民族融合、丝路通途”等四个单元，全面展示春秋战国到秦汉时期的历史面貌。`,
      remark: `2020 年“5·18 国际博物馆日”中国主会场主题展；国家文物局2020年度“弘扬中华优秀传统文化、培育社会主义核心价值观”主题展览重点推介项目`,
      time: '2020年5月17日—9月4日',
      arrowDown: false,
      id: "e",
      imageNumber: 0,
      video: [
        {
          cover: 'video22.jpg',
          video: '2020年度  核心价值观展：融合.mp4'
        }
      ],
      link: [
        {
          cover: 'scene22.jpg',
          link: 'https://audio.taoart.com/fullview/njbwy/3/'
        }
      ]
    },
    f: {
      title: "藏品架起沟通<br>的桥梁",
      textDetail: `2014 年“5·18 国际博物馆日”的主题是“博物馆藏品架起沟通的桥梁”，全国主会场设在南京博物院。为凸显主题，南博特推出“藏品架起沟通的桥梁”主题展。展厅中心以库房存放文物的方式，架构起八百多件文物，两百多个包装箱，从中心延伸出生活、艺术、传统、交流四个主题。展览还展示“我们从哪里来”主题视频，从文物的角度，进一步揭示文物与生活、传统、交流、艺术的关系，架起藏品与人沟通的桥梁，让观众通过文物与历史对话，解读藏品所折射出的丰富内涵。`,
      remark: `2014 年“5·18 国际博物馆日”中国主会场主题展`,
      time: '2014年5月18日—10月15日',
      arrowDown: false,
      id: "f",
      imageNumber: 5,
      video: [
        {
          cover: 'video.jpg',
          video: '藏品展展览视频.mp4',
        }
      ],
      link: [],
    },
  },
  traditionModern: {
    oa: {
      title: "南腔北调—传统<br>戏曲艺术展",
      textDetail: ``,
      remark: ``,
      time: '2015年10月30日-2016年春节',
      arrowDown: false,
      theme: "green",
      id: "oa",
      imageNumber: 16,
      video: [
        {
          cover: '4.jpg',
          video: '南腔北调.mp4',
        }
      ],
      link: [],
    },
    o: {
      title: "走进养心殿—大清<br>的家国天下",
      textDetail: `展览由南京博物院和故宫博物院联合举办，展出文物279 件（套）。以养心殿前殿的象征性场景复原为基础，让公众走进正殿明间、西暖阁、东暖阁、三希堂和佛堂。同时，在展厅周边讲述养心殿造办处、十全老人、垂帘听政等10个单元故事，延伸介绍相关历史事件、人物和故事，梳理从康乾盛世到清帝退位的近200 年间大清朝的悲喜哀乐，以释家国，以启后人。`,
      remark: `2017年度跨年特展`,
      time: '2017年12月22日—2018年3月22日',
      arrowDown: false,
      theme: "green",
      id: "o",
      imageNumber: 8,
      video: [
        {
          cover: 'video12.jpg',
          video: '走进养心殿剪辑0102.mp4'
        }
      ],
      link: [],
    },
    p: {
      title: "温·婉—中国古代<br>女性文物大展",
      textDetail: `展览通过形塑女性、女仕日常、才媛集艺、笔端容功等四个方面，展示中国传统女性的生活和艺术。230件（套）文物范围广、类型多。既有后宫内宰的用器和作品，也有民间普通女性的日常用具；既有集中反映女性生活与劳作的艺术作品，如《春日仕女闲居图》轴，也有男人眼中的女性形象。配合展览，南博还举办了“女人故事会”雅集活动，邀请当代精英女性漫谈生活，展现当代知识女性的风采。`,
      remark: `第十三届（2015年度）全国博物馆十大陈列展览精品展`,
      time: '2015年8月11日—10月31日',
      arrowDown: false,
      theme: "green",
      id: "p",
      imageNumber: 9,
      video: [
        {
          cover: 'video4-1.jpg',
          video: '2015年度  温·婉——中国古代女性文物大展.mp4',
        },
        {
          cover: 'video4-2.jpg',
          video: '温婉女性文物展视频.mp4'
        }
      ],
      link: [],
    },
    q: {
      title: "宋韵—士大夫的<br>精神世界",
      textDetail: `展览由南京博物院和浙江省博物馆共同主办，汇集了来自38家考古文博机构收藏的约300件宋代文物精品，突出浙江宋代考古新发现，包括大量浙江宋代文人士大夫墓葬出土文物，讲述宋代士大夫的治世行道、文艺生活和精神世界。`,
      remark: `2021年跨年特展`,
      time: '2021年12月18日—2022年3月20日',
      arrowDown: false,
      theme: "green",
      id: "q",
      imageNumber: 0,
      video: [
        {
          cover: 'video27.jpg',
          video: '宋韵成片.mp4'
        }
      ],
      link: [
        {
          cover: 'scene27.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=SyWCDe9PYM'
        }
      ]
    },
    r: {
      title: "考古江苏",
      textDetail: `展览展出文物约300 件（套），从“实证鱼米之乡”“追溯文明之源”“探寻古国踪迹”“印证大汉雄风”“勾勒六朝风华”“再现江南盛景”“服务美好生活”等七个方面，回顾了中华人民共和国成立以来，在党的领导和关怀下，江苏考古在探索地域文明、保护文化遗产、服务美好生活上做出的积极贡献，致敬考古先贤，礼赞中华文明。`,
      remark: `中国共产党成立100 周年特展`,
      time: '2021年7月1日—10月8日',
      arrowDown: false,
      theme: "green",
      id: "r",
      imageNumber: 0,
      video: [
        {
          cover: 'video25.jpg',
          video: '考古江苏完整.mp4'
        }
      ],
      link: [
        {
          cover: 'scene25.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=oG9ADoC9R&lang=zh'
        }
      ]
    },
    s: {
      title: "金色中国—中国<br>古代金器大展",
      textDetail: `南京博物院联合内蒙古博物院、陕西历史博物馆、湖北省博物馆和云南省博物馆共同策划的大型金器展。展览共展出金器200 余件（组），分为初露光芒、羽翼渐丰、尽显风范、风情各异和再现辉煌五个部分，分别展示了春秋战国、两汉、两晋隋唐、宋辽金元和明清时代的金器艺术，展示了中国古代金器的风貌、内涵和杰出的工艺成就。`,
      remark: `南京博物院二期改扩建工程开馆之际举办的首个特展`,
      time: '2013年11月6日—2014年2月6日',
      arrowDown: false,
      theme: "green",
      id: "s",
      imageNumber: 5,
      video: [
        {
          cover: 'video.jpg',
          video: '镇护之宝----金兽.mp4',
        },
      ],
      link: [],
    },
    t: {
      title: "法老·王—古埃及文明和<br>中国汉代文明的故事",
      textDetail: `展览由南京博物院和加拿大皇家安大略博物馆共同主办，将包括木乃伊在内的110 件（套）古埃及文物和包括金缕玉衣在内的140 件（套）中国汉代文物放在同一空间对比，从不朽、生活、权力、生灵四个方面揭示文明差异，表现不同文化背景下的相同文化认知。`,
      remark: `第十四届（2016年度）全国博物馆十大陈列展览精品展`,
      time: '2016年8月10日—2017年1月9日',
      arrowDown: false,
      theme: "green",
      id: "t",
      imageNumber: 8,
      video: [
        {
          cover: 'video8.jpg',
          video: '2016年度  法老·王——古埃及文明和中国汉代文明的故事.mp4'
        }
      ],
      link: [],
    },
    u: {
      title: "和·合—中国传统<br>文化中的和谐之道",
      textDetail: `展览从人与自然、人与社会、人与人的关系出发，诠释中华传统文化中的和谐关系。展出文物250多件（套），分为三个部分：第一部分“天人合一”通过认知自然、神灵崇信、人与动物、礼乐制度、小康生活、诚信友善等阐述人和宇宙、自然、社会以及人的关系；第二部分“阴阳和合”用古代传统的辩证法讲述阴阳八卦、阴阳调和、龙凤献瑞、琴瑟和鸣、鸳鸯戏水、和合二仙等相合相成的概念；第三部分“和和美美”分“祥”“和”“喜”“福”4个组合，通过三阳开泰、吉祥如意、花好月圆、四季沐歌、金榜题名、洞房花烛以及全家福等展示圆满幸福的生活真理。`,
      remark: `2015年度国家文物局“弘扬中华优秀传统文化、培育社会主义核心价值观主题展览重点推介项目”`,
      time: '2015年12月26日—2016年4月20日',
      arrowDown: false,
      theme: "green",
      id: "u",
      imageNumber: 8,
      video: [
        {
          cover: 'video6.jpg',
          video: '和合.mp4',
        }
      ],
      link: [],
    },
    v: {
      title: "兄弟王—从满城汉墓<br>到大云山汉墓",
      textDetail: `展览是南京博物院与河北博物院联手打造的反映汉代诸侯王文化、礼仪、生活的展览。“兄弟王”即江都王刘非与中山王刘胜，他们都是汉景帝刘启的儿子、汉武帝刘彻的哥哥。展览分为“诸侯王权”“王室仪轨”“事死如生”“永生之梦”四个部分，将两座陵墓中出土的250件（套）精品文物融合在主题中穿插展示，既是对比展，也是合璧展。`,
      remark: `2019年跨年特展`,
      time: '2019年12月20日—2020年5月31日',
      arrowDown: false,
      theme: "green",
      id: "v",
      imageNumber: 0,
      video: [
        {
          cover: 'video21.jpg',
          video: '兄弟王展览视频完整版(带音乐）.mp4'
        }
      ],
      link: [
        {
          cover: 'scene21.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=wSBbbcQC'
        }
      ]
    },
    w: {
      title: "百花呈瑞—南京博物院<br>藏历代花鸟画迎春特展",
      textDetail: `展览从“宋元：格物致知 翰墨游戏”“明：院体富贵 文人野逸”“清：南昌激越 毗陵优雅 维扬奇异 海上恬美”“二十世纪：写生之趣 写意之韵”等四个时代节点出发，勾勒和诠释了半部中国花鸟画史，这是南博展览史上最全的花鸟画阵容。`,
      remark: `2020年跨年特展`,
      time: '2020年12月26日—2021年3月28日',
      arrowDown: false,
      theme: "green",
      id: "w",
      imageNumber: 0,
      video: [
        {
          cover: 'video24.jpg',
          video: '百花呈瑞展览视频.mp4'
        }
      ],
      link: [
        {
          cover: 'scene24.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=6EapoFLUf'
        }
      ]
    },
    x: {
      title: "青藤白阳—徐渭、陈<br>淳书画艺术特展",
      textDetail: `展览联合了南京博物院、天津博物馆、上海博物馆和苏州博物馆的73件（套）徐渭、陈淳书画精品，全面展示他们的书画艺术面貌和发展源流。通过一流的展品、一流的环境、一流的解读，为观众提供一个直面书画珍品、领略大师风采、品赏艺术情致的机缘，也为学者们搭建一个研究的平台，展览取得不错的效果。`,
      remark: `2017年度特展`,
      time: '2017年8月29日—11月28日',
      arrowDown: false,
      theme: "green",
      id: "x",
      imageNumber: 8,
      video: [
        {
          cover: 'video11.jpg',
          video: '徐渭书画展览~1.mp4'
        }
      ],
      link: [],
    },
    y: {
      title: "仰之弥高—二十世纪<br>中国画大家展",
      textDetail: `展览汇集了代表二十世纪中国画发展最高成就的八位大家：齐白石、黄宾虹、徐悲鸿、潘天寿、张大千、林风眠、傅抱石、李可染的158件（套）经典力作。二十世纪随着“西学东渐”之风的兴起，开启了中西绘画多元并存、融汇创变的新局面。八位大家在大时代变革浪潮中表现出共同的文化特点和精神面貌。他们的中国画创作实践，推进了中国画的变革，拓展了中国画的艺术范畴，将中国画推向了新的发展阶段。`,
      remark: `2019年跨年特展`,
      time: '2019年11月27日—2020年4月20日',
      arrowDown: false,
      theme: "green",
      id: "y",
      imageNumber: 0,
      video: [
        {
          cover: 'video20.jpg',
          video: '仰之弥高展览视频完成.mp4'
        }
      ],
      link: [
        {
          cover: 'scene20.jpg',
          link: 'https://www.4dkankan.com/showPC.html?m=CxwLx9JR'
        }
      ]
    },
    z: {
      title: "帝国盛世—沙俄与<br>大清的黄金时代",
      textDetail: `展览通过俄罗斯联邦国立历史博物馆、故宫博物院、南京博物院的500余件（套）文物，展示公元18至19世纪这一历史时期，俄国的彼得大帝、叶卡捷琳娜二世开创的黄金时代和清朝的康熙乾隆皇帝开创的“康乾盛世”。`,
      remark: `2017年度暑期特展`,
      time: '2017年6月10日—9月10日',
      arrowDown: false,
      theme: "green",
      id: "z",
      imageNumber: 8,
      video: [
        {
          cover: 'video10.jpg',
          video: '帝国盛世预告片新.mp4'
        }
      ],
      link: [],
    },
    za: {
      title: "回家过年",
      textDetail: `展览以“家”“年”和“年代感”为关键词，以新中国成立以来家庭生活状态变迁为轴，通过场景、实物、影像、装置等，将60 年代、80 年代和00 年代的年味“搬进”展厅。展览可触摸、可把玩、可落座，让观众身临其境，重温“家”的味道。`,
      remark: `2018年度国家文物局“弘扬中华优秀传统文化、培育社会主义核心价值观主题展览重点推介项目”`,
      time: '2018年2月2日—4月10日',
      arrowDown: false,
      theme: "green",
      id: "za",
      imageNumber: 9,
      video: [
        {
          cover: 'cover.jpg',
          video: '回家过年.mp4',
        }
      ],
      link: [],
    },
    zb: {
      title: "潘玉良绘画特展",
      textDetail: `坐西怀东，涅槃重生，如旗袍般优雅诠释印象西方，以奇绝风骨展现万千姿态。时光流转因与果，命运跌宕瞬白头；不以名利作为念，当在湖山秀丽多。画布上，力透纸背，心绪斑斓。她，潘玉良，倾其一生书情写爱，道尽世间无数……展览展示安徽博物院藏潘玉良的绘画作品及旗袍共80余件。`,
      remark: `2022年度特展`,
      time: '2022年7月16日—2022年10月10日',
      arrowDown: false,
      theme: "green",
      id: "zb",
      imageNumber: 30,
      video: [
        {
          cover: 'cover.jpg',
          video: '潘玉良展.mp4',
        }
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KJ-QufFKMxgrh&lang=zh'
        }
      ],
    },
    zc: {
      title: "晋国展",
      textDetail: `西周时期，晋、吴青铜器均呈现出继承宗周文化并融合本地文化之特点。春秋时期，晋、吴交融，在今山西太原、忻州等晋国故地发现了许多吴国青铜器，也见证了两周时期中华大地上文化的交流与互鉴。本展览展出来自山西博物院的231件(套)精品文物，通过“河汾骄子”“争霸春秋”“余烈三晋”三个单元，集中展示从“桐叶封弟”到“三家分晋”，晋国六百年伟业。`,
      remark: `2022年度特展`,
      time: '2022年6月25日—2022年10月7日',
      arrowDown: false,
      theme: "green",
      id: "zc",
      imageNumber: 10,
      video: [
        {
          cover: 'cover.jpg',
          video: '晋国特展定版.mp4',
        }
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spc.html?m=KK-8Tk8KgYrAZ&lang=zh',
        }
      ],
    },
    zd: {
      title: "大江万古流—长江<br>下游文明特展",
      textDetail: `展览集合长江下游10家文博单位，精心挑选了约250组（件）展品，通过4个部分：“江水天上来”“万水千帆过”“何处是江南”“共饮一江水”，向观众展示长江下游地区的文明起源与发展历程、文化高峰时期物质和精神文明的物证，以及当下城市文明的斑斓光影。`,
      remark: `2023年跨年特展`,
      time: '2022年12月31日—2023年3月31日',
      arrowDown: false,
      theme: "green",
      id: "zd",
      imageNumber: 12,
      video: [
        {
          cover: 'cover.jpg',
          video: '大江万古流展览视频长篇.mp4',
        }
      ],
      link: [
        {
          cover: 'cover.jpg',
          link: 'https://www.4dkankan.com/spg.html?m=KJ-7kF1fSqwee',
        }
      ],
    }
  },
}
